import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import BlockIcon from '@material-ui/icons/Block';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

function renderDeclineOrderAlertComponents(props) {
  if (!props.isOrderDeclineAlert) {
    return null;
  }

  return (
    <div>
      <TextField
        autoFocus
        margin="dense"
        id="note"
        label="Notiz"
        type="text"
        fullWidth
        value={props.note}
        onChange={e => props.noteTextFieldChanged(e.target.value)}
      />
      {/* <FormControlLabel
        control={
          <Checkbox
            icon={<CheckBoxOutlineBlankIcon />}
            checkedIcon={<BlockIcon />}
            name="checkedH"
            checked={props.blockUser}
            onChange={props.blockUserCheckBoxClicked}
          />
        }
        label="Benutzer sperren"
      /> */}
    </div>
  );
}


function AlertDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <Dialog
      fullScreen={fullScreen}
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.message}
        </DialogContentText>
        {renderDeclineOrderAlertComponents(props)}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onDismiss} color="primary">
          {props.dismissText}
        </Button>
        <Button onClick={props.onAgree} color="primary" autoFocus>
          {props.agreeText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  isOrderDeclineAlert: PropTypes.bool.isRequired,
  dismissText: PropTypes.string,
  agreeText: PropTypes.string,
  onDismiss: PropTypes.func,
  onAgree: PropTypes.func,
};

AlertDialog.defaultProps = {
  dismissText: 'Abbrechen',
  agreeText: 'Ok',
  onDismiss: () => { },
  onAgree: () => { },
  isOrderDeclineAlert: false,
  blockUser: false,
  note: '',
};

export default AlertDialog;
